import React, { useState, useEffect } from 'react';
import { createAPIEndpoint3, ENDPIONTS } from "../../api";
import { List, ListItem, ListItemText, Paper, InputBase, IconButton, makeStyles, ListItemSecondaryAction } from '@material-ui/core';
import SearchTwoToneIcon from '@material-ui/icons/SearchTwoTone';
import PlusOneIcon from '@material-ui/icons/PlusOne';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';

const useStyles = makeStyles(theme => ({
    searchPaper: {
        padding: '2px 4px',
        display: 'flex',
        alignItems: 'center',
    },
    searchInput: {
        marginLeft: theme.spacing(1.5),
        flex: 1,
    },
    listRoot: {
        marginTop: theme.spacing(1),
        maxHeight: 450,
        overflow: 'auto',
        '& li:hover': {
            cursor: 'pointer',
            backgroundColor: '#E3E3E3'
        },
        '& li:hover .MuiButtonBase-root': {
            display: 'block',
            color: '#000',
        },
        '& .MuiButtonBase-root': {
            display: 'none'
        },
        '& .MuiButtonBase-root:hover': {
            backgroundColor: 'transparent'
        }
    }
}))

export default function SearchFoodItems(props) {

    const { values, setValues } = props;
    let orderedFoodItems = values.orderDetails;

    const [foodItems, setFoodItems] = useState([]);
    const [searchList, setSearchList] = useState([]);
    const [searchKey, setSearchKey] = useState('');
    const classes = useStyles();

    //let idalumno = sessionStorage.getItem('_CARRITO_IDALUMNO');
    let idalumno = props.alumnoid;
    let cicloseleccionado = values.customerId;

    //console.log("--------->>>>" + idalumno);

    //console.log("CICLO ESCOLAR --------->>>>" + cicloseleccionado);

    const h = "";

    useEffect(() => {
        createAPIEndpoint3(ENDPIONTS.CATALOGOCOBRO).fetchAllPriceByStudent(idalumno, cicloseleccionado)
            .then(res => {
                setFoodItems(res.data);
                setSearchList(res.data);
            })
            .catch(err => console.log(err))

    }, [idalumno, cicloseleccionado])

    useEffect(() => {
        let x = [...foodItems];
        x = x.filter(y => {
            return y.foodItemName.toLowerCase().includes(searchKey.toLocaleLowerCase())
                && orderedFoodItems.every(item => item.foodItemId != y.foodItemId)
        });
        setSearchList(x);
    }, [searchKey, orderedFoodItems])

    const addFoodItem = foodItem => {
       // debugger
        let x = {
            orderMasterId: values.orderMasterId,
            orderDetailId: 0,
            foodItemId: foodItem.foodItemId,
            quantity: 1,
            ajuste: 0,
            tipoajuste:'',
            foodItemPrice: foodItem.price,
            foodItemName: foodItem.foodItemName,
            tipo: foodItem.tipo,
            descuento: foodItem.descuento,
            porcentajebeca: foodItem.porcentajebeca,
            descuentoprontopago: foodItem.descuentoprontopago,
            porcentajecargomoratorio: foodItem.porcentajecargomoratorio,
            costocolegiatura: foodItem.costocolegiatura,
            mespagocolegiatura: foodItem.mespagocolegiatura,
            mesconsecutivopagocolegiatura: foodItem.mesconsecutivopagocolegiatura,
            pagocolegiatura: foodItem.pagocolegiatura,
            id: foodItem.id,
            fooditempricereal:0,
            cerrarcorte:false,
            idusuario: sessionStorage.getItem('idusuario'),
            pmethod: '',
            motivoajuste:''
        }
        setValues({
            ...values,
            orderDetails: [...values.orderDetails, x]
        })
    }

    return (
        <>
            <Paper className={classes.searchPaper}>
                <InputBase
                    className={classes.searchInput}
                    value={searchKey}
                    onChange={e => setSearchKey(e.target.value)}
                    placeholder="Buscar Servicios / Colegiaturas" />
                <IconButton>
                    <SearchTwoToneIcon />
                </IconButton>
            </Paper>
            <List className={classes.listRoot}>
                {
                    searchList.map((item, idx) => (
                        <ListItem
                            key={idx}
                            onClick={e => addFoodItem(item)}>
                            <ListItemText
                                primary={item.foodItemName + ((item.tipo === 'COLEGIATURA') ? (' $'+item.price) : '') }
                                secondary={'$' + ((item.tipo === 'COLEGIATURA') ? (item.price + ' | Pago Normal:' + item.costocolegiatura + ' | % Beca:' + item.porcentajebeca + ' |Moratorio:' + item.porcentajecargomoratorio+'%') : item.price )} />
                            <ListItemSecondaryAction>
                                <IconButton onClick={e => addFoodItem(item)}>
                                    <PlusOneIcon />
                                    <ArrowForwardIosIcon />
                                </IconButton>
                            </ListItemSecondaryAction>
                        </ListItem>
                    ))
                }
            </List>
        </>
    )
}
